import React from 'react';

import PropTypes from 'prop-types';

import ValueItem from 'components/Widgets/Profile/ValueItem';

export default function Industry({ member }) {
  return (

    <ValueItem
      icon="company-industry-icon"
      label="Industry"
    >
      {member.industries.join(', ')}
    </ValueItem>
  );
}

Industry.propTypes = {
  member: PropTypes.object.isRequired,
};
